import { render } from "./group.vue?vue&type=template&id=2ed23944&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"

import "./group.vue?vue&type=style&index=0&id=2ed23944&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2ed23944"

export default script